export default "__VITE_ASSET__DQt4ptCE__"